import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { APP_CONFIG, IAppConfig } from '../../app.config';
import { MessageService } from '../../core/service/message.service';
import { ProgressBarService } from '../../core/service/progress-bar.service';
import { DataService } from '../../core/service/base/data.service';
import { PriceList } from '../model/pricelist';
import { MeterMediaType } from '../model/const/enums';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { MeterModel } from '../model/meter-model';
import { SelectionItem } from '../../core/component/select/select.component';

@Injectable()
export class MeterModelService extends DataService<MeterModel> {
  private readonly _default_FilterFields: string[] = ['meterType', 'manufacturer'];

  getSelection(meterType: MeterMediaType): Observable<SelectionItem[]> {
    return this.client
      .get<MeterModel[]>(`${this.endpoint}/type/${meterType}`)
      .pipe(map(res => res.map(t => this.createModel(t)).map(t => t.toSelectionItem())));
  }

  constructor(client: HttpClient, @Inject(APP_CONFIG) config: IAppConfig, messageService: MessageService, progressBar: ProgressBarService) {
    super(client, config, messageService, MeterModel, progressBar, 'imd-meter-model');
  }

  getFilterDefinition(): Observable<{
    name: string;
    meterType: MeterMediaType;
    manufacturer: string;
    selectedFields: string[];
    defaultFields: string[];
  }> {
    return this.client
      .get<any>(`${this.endpoint}/filter`)
      .pipe(
        map(res => {
          return {
            name: res.name ? res.name : '',
            meterType: res.meterType,
            manufacturer: res.manufacturer ? res.manufacturer : '',
            selectedFields: Array.isArray(res.selectedFields) ? res.selectedFields : this._default_FilterFields,
            defaultFields: this._default_FilterFields,
          };
        })
      )
      .pipe(
        catchError(error => {
          console.log(error);
          return [];
        })
      );
  }
}
